import { cloudApi, cloudFetch } from './http.js'

function query(values) {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(values)) {
    if (value !== undefined && value !== null && value !== '') params.set(key, String(value))
  }
  return params.toString()
}

export const materialAssetsApi = Object.freeze({
  capacity(tenantId, projectId) {
    return cloudApi.get(`/api/tenants/${tenantId}/projects/${projectId}/material-schedule/library-capacity`)
  },
  list(tenantId, projectId, { statuses = 'ready,needs_review,blocked,archived' } = {}) {
    return cloudApi.get(`/api/tenants/${tenantId}/material-assets?${query({ project_id: projectId, status: statuses })}`)
  },
  upload(tenantId, projectId, file, metadata, options = {}) {
    if (!(file instanceof File)) throw new TypeError('file must be a browser File')
    const form = new FormData()
    form.append('file', file, file.name)
    if (metadata.pastedSource) form.append('pasted_source', JSON.stringify(metadata.pastedSource))
    const params = query({
      project_id: projectId,
      role: metadata.role,
      asset_type: file.type === 'application/pdf' ? 'document' : 'image',
      name: metadata.name || file.name,
      authorization_scope: metadata.authorizationScope,
      allowed_platforms: (metadata.allowedPlatforms || []).join(','),
      can_remix: metadata.canRemix,
      privacy_masked: metadata.privacyMasked,
      // Cloud stores the canonical proof enum.  "high" was an early web-only
      // label and is not part of the persisted contract.
      proof_level: metadata.proofLevel || 'strong',
      enterprise_description: metadata.enterpriseDescription,
    })
    return cloudFetch(`/api/tenants/${tenantId}/material-assets/upload?${params}`, {
      method: 'POST', body: form, timeoutMs: 120_000, idempotencyKey: options.idempotencyKey,
    })
  },
  withdraw(tenantId, assetId) {
    return cloudApi.patch(`/api/tenants/${tenantId}/material-assets/${assetId}`, { status: 'archived' })
  },
  updateDescription(tenantId, assetId, enterpriseDescription, pastedSource = null) {
    return cloudApi.patch(`/api/tenants/${tenantId}/material-assets/${assetId}`, {
      enterprise_description: enterpriseDescription,
      pasted_source: pastedSource,
    })
  },
})
